import { useDispatch, useSelector } from "react-redux";
import CourseCardComponentB2c from "./CourseCardComponentB2c";
import { useCallback, useEffect, useState } from "react";
import { getProductCategories } from "../../redux/courses/actions";
import { SessionKeys, getStepIndex } from "../../utils/AppUtils";
import _ from "lodash";
import Loader from "../Loader/Loader";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
// import FilterAndSearchSection from "./FilterAndSearchSection";
import CourseListingMainComponent from "./CourseListingMainComponent";
import LPListingContentComponent from "../NewDesign/ListingContent/LPListingContent/LPListingContentComponent";
import useLogin from "../../custom-hooks/useLogin";
import { useNavigate } from "react-router-dom";
import NewCourseListingMainComponent from "./NewCourseListingMainComponent";
import { setJoyRideReq } from "../../redux/assignCourse/actions";
import CourseListingMyCourse from "./CourseListingMyCourse";
import CourseListingPopularCourse from "./CourseListingPopularCourse";

const CourseListLearnComp = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoggedIn, userData } = useLogin()
    const userRole = useSelector((state) => state.user.role);
    const authBroker = useSelector((state) => state.auth.authBroker);
    const isPremiumUser = useSelector((state) => state.user.isPremiumUser);


    const search = window.location.search;
    const params = new URLSearchParams(search);
    const c = params.get("c");
    let providerId = "";
    let providerName="";
    let allPartners ="";
    if (c) {
        let decodedString = atob(c);
        let paramsReq = JSON.parse(decodedString);
        providerId = paramsReq.provider_id;
        allPartners = paramsReq?.allPartners;
        providerName = paramsReq?.provider_name;
    }
    // const providerId = params.get("provider_id");
    console.log("allPartners---",allPartners)
    const [key, setKey] = useState('')
    const tab = params.get("tab");


    

    useEffect(() => {
        console.log("Tab: ", tab)
        setTimeout(() => {
            if (tab === "1") {
                setKey("AllCourses")
            } else if (tab === "2") {
                setKey("MyCourses")
            } else if (tab === "3") {
                setKey("popular")
            } else if (tab === "4") {
                setKey("my-non-oblp")
            } else if (tab === "5") {
                setKey("my-oblp")
            } else if (tab === "6") {
                setKey("NewCourses")
            }
        }, 200);

    }, [tab])

    useEffect(() => {
        if (
            sessionStorage.getItem(SessionKeys.IS_TOUR) === "YES" &&
            !_.isEmpty(authBroker)
        ) {
            const isGuest = authBroker.payload.user.role.includes("guest");
            const stepIndex = getStepIndex(
                "#idCoursesMenu",
                userRole,
                isPremiumUser,
                isGuest
            );
            dispatch(setJoyRideReq({ run: true, stepIndex: stepIndex }));
        }
    }, [])



    const showMyOnboard = useCallback(() => {
        if (!_.isEmpty(userData.role)) {
            console.log(userData.role)
            if (!userData.role.includes('customer')) return true;
        }
        return false
    }, [userData])

    const renderCourseComp = () => {
        if (key === 'AllCourses') {
            return (
                <CourseListingMainComponent
                    isAllCourse={key === 'AllCourses'}
                    isMyCourse={key === 'MyCourses'}
                    isFilterShow={['popular'].includes(key)}
                    isPopular={key === 'popular'}
                    tabKey={key} />
            )
        }else {
            return ""
        }
    }

    const renderMyCourseComp = () => {
        if (key === 'MyCourses') {
            console.log(key)
            return (
                <CourseListingMyCourse
                    isFilterShow={false}
                    tabKey={key} />
            )
        }else {
            return ""
        }
    }

    const renderPopularCourseComp = () => {
        if (key === 'popular') {
            console.log(key)
            return (
                <CourseListingPopularCourse
                    isFilterShow={false}
                    tabKey={key} />
            )
        }else {
            return ""
        }
    }


    const renderNewCourseComp = () => {
        if (key === 'NewCourses') {
            console.log(key)
            return (
                <NewCourseListingMainComponent
                    isFilterShow={false}
                    tabKey={key} />
            )
        }else {
            return ""
        }
    }

    const renderLPComp = () => {
        if (key === 'all-non-oblp' ||
            key === 'my-non-oblp' ||
            key === 'my-oblp') {
            console.log(key)
            return (
                <LPListingContentComponent
                    isAllLP={key === 'all-non-oblp'}
                    isMyOBLP={key === 'my-oblp'}
                    isMyLP={key === 'my-non-oblp'}
                    tabKey={key}
                />
            )
        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {

        };
    }, []);

    // Leader&rsquo;s
    const renderTitle = () => {
        return (
        <div dangerouslySetInnerHTML={{__html: allPartners ? `Courses from ${authBroker?.payload?.user?.config?.partner_menu_text !== undefined && !_.isEmpty(authBroker?.payload?.user?.config?.partner_menu_text)?
            authBroker?.payload?.user?.config?.partner_menu_text?.toLowerCase():
            "Learning Partners"}` : providerName ? `Courses from ${providerName}` : "All courses"}}></div>
        )
    }

    return (
        <>
            <div className="contsection">

                <nav>
                    <div className="nav-section-box" id="nav-tab" role="tablist">
                        {false && <button className="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">All courses</button>}
                        <Tabs
                            underline
                            activeKey={key}
                            onSelect={(k) => {
                                // setIsFetching(true)
                                console.log('selectKey: ', k)
                                if(allPartners || providerName) {

                                }
                                else if (k === "AllCourses") {
                                    navigate("/learn/courses?tab=1", { replace: true });
                                } else if (k === "MyCourses") {
                                    navigate("/learn/courses?tab=2", { replace: true });
                                    // } else if (k === "all-non-oblp") {
                                    //     navigate("/learn/courses?tab=3", {replace: true});
                                    // } else if (k === "my-non-oblp") {
                                    //     navigate("/learn/courses?tab=4", {replace: true});
                                    // } else if (k === "my-oblp") {
                                    //     navigate("/learn/courses?tab=5", {replace: true});
                                } else if (k === "NewCourses") {
                                    navigate("/learn/courses?tab=6", { replace: true });
                                } else if (k === "popular") {
                                    navigate("/learn/courses?tab=3", { replace: true });
                                }

                                if(document.getElementById("idFooter")!==null){
                                    document.getElementById("idFooter").style.display = 'none'
                                }
                                if(allPartners || providerName) {

                                } else { setKey("") }
                               
                                setTimeout(() => {
                                    setKey(k)
                                    if(document.getElementById("idFooter")!==null){
                                        document.getElementById("idFooter").style.display = 'block'
                                    }
                                }, 200);
                                // setVideoListing(CONFIG.INITIAL_PRODUCT_CARD_DATA)
                            }}
                        >
                            <Tab eventKey={'AllCourses'}
                                title={renderTitle()}
                            >
                                {renderCourseComp()}
                            </Tab>
                            { !providerId && !allPartners && <Tab eventKey={'popular'} title="Most Popular Courses">
                                {renderPopularCourseComp()}
                            </Tab> }
                            {(isLoggedIn && !providerId) && !allPartners && 
                                <Tab eventKey={'NewCourses'} title="New courses">
                                    {renderNewCourseComp()}
                                </Tab>}
                            {(isLoggedIn && !providerId) && !allPartners && 
                                <Tab eventKey={'MyCourses'} title="My courses">

                                    {renderMyCourseComp()}
                                </Tab>
                            }
                            {!providerId && false &&
                                <Tab eventKey={'all-non-oblp'} title="All learning path">
                                    {key === 'all-non-oblp' && renderLPComp()}
                                </Tab>}
                            {(isLoggedIn && !providerId) && false &&
                                <Tab eventKey={'my-non-oblp'} title="My learning path">
                                    {key === 'my-non-oblp' && renderLPComp()}
                                </Tab>}
                            {(isLoggedIn && !providerId && showMyOnboard) && userRole !== 'customer' && false &&
                                <Tab eventKey={'my-oblp'} title="My onboarding path">
                                    {key === 'my-oblp' && renderLPComp()}
                                </Tab>}
                        </Tabs>

                    </div>
                </nav>


            </div>
        </>
    )

}
export default CourseListLearnComp;